// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresGuestListBody = {
  poolId: string;
};

export type typeSquaresGuestListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    guests: {
      guestId: string;
      firstName: string;
      lastName: string;
      initials: string;
      displayName: string;
      createdByUserId: string;
      squareCount: number;
    }[];
  };
};

export type typeSquaresGuestListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGuestListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGuestListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresGuestListBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresGuestList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresGuestListBody);
  }

  return async function postSquaresGuestList(
    payload: typeSquaresGuestListBody,
  ): Promise<typeSquaresGuestListOutput200 | typeSquaresGuestListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresGuestList" failed before calling the network. #e33da6629773`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#e33da6629773" },
        },
        data: null,
      } as typeSquaresGuestListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/guest-list`,
      httpMethod: "POST",
      options,
    })) as typeSquaresGuestListOutput200 | typeSquaresGuestListOutput400;
  };
}
